import { createTheme, MantineColorsTuple } from "@mantine/core";

// Shade 0 = card background, shade 9 = screen background / heading
const navyBlue: MantineColorsTuple = [
  "#d6e8f5",
  "#bdd8ee",
  "#96c0e3",
  "#6da6d8",
  "#488ccc",
  "#2c72bf",
  "#1a5aa8",
  "#134590",
  "#0e3070",
  "#0d1b3e",
];

export const theme = createTheme({
  primaryColor: "navyBlue",
  primaryShade: 7,
  fontFamily: "Arial, sans-serif",
  colors: {
    navyBlue,
  },
});

/** @deprecated use `theme` */
export const baseTheme = theme;
/** @deprecated use `theme` */
export const tabletTheme = theme;
/** @deprecated use `theme` */
export const laptopTheme = theme;
